(function () {
    'use strict';

    angular.module("imApp").factory("checkListDataService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 922,
                    parameters: parms || {}
                });
            },
            listCheckListDatas: function (parms) {
                return $ihttp.post({
                    method: 231,
                    parameters: parms || {}
                });
            },
            computeValidation: function (item) {
                return $ihttp.post({
                    method: 1583,
                    parameters: item
                });
            },
            saveObj: function (inputListCheckListDatas) {
                return $ihttp.post({
                    method: 267,
                    parameters: inputListCheckListDatas
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 262,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
